import { supabase } from '@/core/database/supabase';
import type { ProjectDetail } from '../types/projectDetail.types';

export const projectDetailService = {
  async getProject(id: string): Promise<ProjectDetail | null> {
    const { data, error } = await supabase
      .from('projects')
      .select(`
        *,
        pm:user_profiles!pm_user_id(id, full_name, avatar_path),
        site_manager:user_profiles!site_manager_user_id(id, full_name, avatar_path)
      `)
      .eq('id', id)
      .single();

    if (error || !data) return null;

    const rawDescription = data.description || '';
    const metaMatch = rawDescription.match(/\[METADATA\]: (\{.*\})/);
    let meta: any = {};
    let pureDescription = rawDescription;

    if (metaMatch) {
      try {
        meta = JSON.parse(metaMatch[1]);
        pureDescription = rawDescription.replace(/\[METADATA\]: \{.*\}/, '').trim();
      } catch (e) {
        console.error('Error parsing metadata from description:', e);
      }
    }

    const members = [];
    if (data.pm) {
      members.push({ id: data.pm.id, fullName: data.pm.full_name, avatarUrl: data.pm.avatar_path, role: 'Project Manager' });
    }
    if (data.site_manager) {
      members.push({ id: data.site_manager.id, fullName: data.site_manager.full_name, avatarUrl: data.site_manager.avatar_path, role: 'Site Manager' });
    }

    return {
      id: data.id,
      code: data.code,
      name: data.name,
      clientName: data.client_name,
      location: data.location,
      projectType: data.project_type,
      statusCode: data.status_code,
      description: pureDescription,
      startDate: data.start_date,
      endDate: data.end_date,
      contractAmount: data.contract_amount || 0,
      budgetAmount: data.budget_amount || 0,
      completionPct: data.completion_pct || 0,
      members,
      createdAt: data.created_at,
      // Map from metadata
      thumbnailUrl: meta.thumbnail || '',
      attachments: meta.attachments || [],
      managementUnit: meta.managementUnit || '',
      duration: meta.duration || '',
      contractType: meta.contractType || '',
      priority: meta.priority || 'medium',
      note: meta.note || '',
    };
  }
};
